// extracted by mini-css-extract-plugin
module.exports = {"container":"DotsSelector_container__oqy1l","labels":"DotsSelector_labels__1zGm2","activeLabel":"DotsSelector_activeLabel__i8Xs9"};